import { Pipe } from '@angular/core';
import { PipeTransform } from '@angular/core';

@Pipe({ name: 'azurefolder' })
export class AzureFolderNamePipe implements PipeTransform {
  transform(value: any) {
    let specialCharsReplacers: any = ['_FSLASH', '_BSLASH'];
    let specialCharsRegEx = /[ /\ ]/;
    if (specialCharsRegEx.test(value)) {
      let formattedValue = value;
      formattedValue = formattedValue.replace(/[\/]/g, specialCharsReplacers[0]);
      formattedValue = formattedValue.replace(/[\\]/g, specialCharsReplacers[1]);
      return formattedValue;
    }
    return value;
  }
}
